/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Start_Page_Service_SessionInputs */

const en_start_page_service_session = /** @type {(inputs: Start_Page_Service_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`60 min · Strength Studio`)
};

const pl_start_page_service_session = /** @type {(inputs: Start_Page_Service_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`60 min · Studio Siła`)
};

/**
* | output |
* | --- |
* | "60 min · Strength Studio" |
*
* @param {Start_Page_Service_SessionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const start_page_service_session = /** @type {((inputs?: Start_Page_Service_SessionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Start_Page_Service_SessionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_start_page_service_session(inputs)
	return en_start_page_service_session(inputs)
});